"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShortName = void 0;
var ShortName;
(function (ShortName) {
    ShortName["RFA1"] = "RFA1";
    ShortName["RFA3"] = "RFA3";
    ShortName["RFA4"] = "RFA4";
    ShortName["RFA5"] = "RFA5";
    ShortName["RFA6"] = "RFA6";
    ShortName["RFA8"] = "RFA8";
    ShortName["RFA9"] = "RFA9";
    ShortName["RFA1_13"] = "RFA1_13";
    ShortName["RFA14_15"] = "RFA14_15";
    ShortName["RFA16"] = "RFA16";
    ShortName["RFA17"] = "RFA17";
    ShortName["RFA21"] = "RFA21";
    ShortName["RFA22"] = "RFA22";
    ShortName["RFA23"] = "RFA23";
})(ShortName = exports.ShortName || (exports.ShortName = {}));
